export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/caigouhetongzhiliangbaoxian-4c590a0be0056292ea35b46d1ea61901.png";